import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { ColourScheme, NewDealerGroup, Report } from '../models/dealership.model';
import { GenericIdName } from '../models/digitalForm.model';
import { DealershipService } from '../services/dealership.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-dealergroup-modal',
  templateUrl: './add-dealergroup-modal.component.html',
  styleUrls: ['./add-dealergroup-modal.component.scss']
})
export class AddDealergroupModalComponent implements OnInit {
  dealerGroupName: string;
  reportIds: number[];
  colourSchemes: ColourScheme[]
  FluidReportList: Report[];
  selectedColourSchemeId: number;
  dealershipLogo: string;
  dealershipReportLogo: string;

  ImageFile: File;
  ImageReFileReport: File;

  newDG: boolean = false;
  dealergroupId: number;
  constructor(public dialogRef: MatDialogRef<AddDealergroupModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private _dealershipService: DealershipService, public snackBar: MatSnackBar, private _notifications: NotificationsService) { }

  ngOnInit() {
    this.newDG = this.data.newDG
    this.dealergroupId = this.data.dealergroupId
    this._dealershipService.getAllColourSchemes().subscribe(response => {
      this.colourSchemes = response;

    });
    this._dealershipService.getAllReportTypes().subscribe(res => {
      this.FluidReportList = res;
    })


    if(this.dealergroupId>0){
      this.LoadDealerGroupDetails();
    }
  }


LoadDealerGroupDetails(){
  this._dealershipService.getDealerGroupDetails(this.dealergroupId).subscribe(res=>{
    this.dealerGroupName = res.DealerGroupName;
    this.reportIds = res.ReportId;
    
    this.selectedColourSchemeId = res.StyleId;

    if(res.dealershipLogo!=""){
      this.dealershipLogo= 'data:image/png;base64,' + res.dealershipLogo
    }else{
      this.dealershipLogo ='';
    }

    if(res.dealershipReportLogo!=""){
      this.dealershipReportLogo= 'data:image/png;base64,' + res.dealershipReportLogo
    }else{
      this.dealershipReportLogo ='';
    }

  })
}

  addNewDealerGroup() {
    console.log("data", this.reportIds, this.selectedColourSchemeId, this.dealerGroupName)
    if (this.dealerGroupName.length < 1 || this.dealerGroupName == "" || this.dealerGroupName == undefined) {
      this.snackBar.open('Please fill in all required fields (*)', '', {
        duration: 1500,
      });
      return;
    }

    if (this.reportIds.length == 0 || this.reportIds == null || this.reportIds == undefined) {
      this.snackBar.open('Please fill in all required fields (*)', '', {
        duration: 1500,
      });
      return;
    }

    if (this.selectedColourSchemeId == null || this.selectedColourSchemeId == 0 || this.selectedColourSchemeId == undefined) {
      this.snackBar.open('Please fill in all required fields (*)', '', {
        duration: 1500,
      });
      return;
    }

    let newDealership: NewDealerGroup = {
      DealerGroupName: this.dealerGroupName,
      ReportId: this.reportIds,
      StyleId: this.selectedColourSchemeId,
      dealershipLogo: this.dealershipLogo,
      dealershipReportLogo:this.dealershipReportLogo,
      Id:0,
    }
    this._dealershipService.addNewDealerGroup(newDealership).subscribe(result => {

      if (!(result > 0)) {
        this._notifications.error('Failed', 'A dealerGroup with this name already exists. ');
      } else {
        this._notifications.success('DealerGroup Added', 'This dealergroup has been added successfully. ');
        this.dialogRef.close(true);
      }
    });

  }

  UpdateDealerGroup(){
    if (this.dealerGroupName.length < 1 || this.dealerGroupName == "" || this.dealerGroupName == undefined) {
      this.snackBar.open('Please fill in all required fields (*)', '', {
        duration: 1500,
      });
      return;
    }

    if (this.reportIds.length == 0 || this.reportIds == null || this.reportIds == undefined) {
      this.snackBar.open('Please fill in all required fields (*)', '', {
        duration: 1500,
      });
      return;
    }

    if (this.selectedColourSchemeId == null || this.selectedColourSchemeId == 0 || this.selectedColourSchemeId == undefined) {
      this.snackBar.open('Please fill in all required fields (*)', '', {
        duration: 1500,
      });
      return;
    }

    let newDealership: NewDealerGroup = {
      DealerGroupName: this.dealerGroupName,
      ReportId: this.reportIds,
      StyleId: Number(this.selectedColourSchemeId),
      dealershipLogo: this.dealershipLogo,
      dealershipReportLogo:this.dealershipReportLogo,
      Id:this.dealergroupId
    }
    this._dealershipService.UpdateDealerGroup(newDealership).subscribe(result => {

      if (!(result > 0)) {
        this._notifications.error('Failed', 'A dealerGroup with this name already exists. ');
      } else {
        this._notifications.success('DealerGroup Updated', 'This dealergroup has been update successfully. ');
        this.dialogRef.close(true);
      }
    });
  }

  onSelectImage(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.ImageFile = event.target.files[0];

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.dealershipLogo = event.target["result"];
      }
    }
  }

  onSelectReportImage(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      this.ImageReFileReport = event.target.files[0];

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.dealershipReportLogo = event.target["result"];
      }
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }




}
